import { useQuery } from "react-query";
import axios from "../axios";

const useGetSendBags = ({ seller_id, search, sort }) => {
  const query = useQuery(
    ["sendBags", seller_id, search, sort], // <-- include sort and seller_id in the key
    async () => {
      const response = await axios.get(
        `/api/sendbag/seller?requested_by=${seller_id}&sort=${sort}&search=${search}` //
      );
      return response.data;
    },
    {
      enabled: !!seller_id, // only fetch when seller_id exists
    }
  );

  return query;
};

export default useGetSendBags;
